// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"a01808dc","238":"b4faa30d","442":"31c3eb0b","453":"b65a4ae5","530":"fb246197","589":"2602d1af","606":"97df3a74","645":"f849a3f7","753":"db72d5f6","840":"333048ed","984":"7e95db4f"}[chunkId] + ".chunk.js";
};